export default "__VITE_ASSET__BKkQ44Oy__"